module.exports = __webpack_public_path__ + "static/media/tz.d4dce847.svg";